import globalEvents from '@common/globalEvents/globalEvents'

import errorModal from './errorModal'

/**
 * A futásidejű és promise hibák elkapását bekapcsoló függvény.
 * @param runtimeErrorTitle   - A futásidejű hibák címe.
 * @param unhandledErrorTitle - A nem kezelt promise hibák címe.
 */
export default function listenErrors (
  runtimeErrorTitle = 'Futásidejű hiba!',
  unhandledErrorTitle = 'Nem kezelt aszinkron hiba!'
): void {
  // https://developer.mozilla.org/en-US/docs/Web/API/Window/error_event
  globalEvents.onError((e) => {
    errorModal(e, 'runtime', runtimeErrorTitle)
  })

  // https://developer.mozilla.org/en-US/docs/Web/API/Window/unhandledrejection_event
  globalEvents.onUnhandledRejection((e) => {
    errorModal(e, 'unhandledpromise', unhandledErrorTitle)
  })
}
